import openWindow from '@/script/openWindow.mjs'
import {useMapContext} from '@/components/MindMap/index.mjs'

export default props => {
    const map = useMapContext()
    const {mapTypeCode} = map.data

    if ('_DB_MAP' !== mapTypeCode) {
        return null
    }

    const onClick = () => {
        const {pkid: dbId, prjId, sVer} = map.root.data
        openWindow('/LlmDtGenDoMasterList', {dbId, prjId, sVer})
    }

    return {
        label: '业务对象清单',
        onClick,
        ...props
    }
}
